import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const ResultContainer: FC<ComponentProps<"div">> = ({
  className,
  children,
  ...rest
}) => (
  <div
    className={cls(
      "mt-4 first:mt-0 py-3 px-4 rounded shadow-[inset_0_1px_4px_rgb(0_0_0_/_4%),_0_1px_0_#fff] border border-solid border-gray-300 bg-gray-200",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

export default ResultContainer;
